"use client";

import { usePathname } from "next/navigation";
import { useAuth } from "@/context/AuthContext";
import { DashboardLayout } from "./DashboardLayout";

// Pages that don't need the dashboard layout
const PUBLIC_PAGES = [
  "/login",
  "/register",
  "/forgot-password",
  "/reset-password",
  "/verify-email",
  "/resend-verification",
];

// Pages that need the dashboard layout
const AUTHENTICATED_PAGES = [
  "/dashboard",
  "/master-report",
  "/amber-alert",
  "/budget-pacing",
  "/admin",
  "/profile",
  "/docs",
];

export function AuthenticatedLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const { user, loading } = useAuth();

  // Check if current page is public
  const isPublicPage = PUBLIC_PAGES.some((page) => pathname.startsWith(page));

  // Check if current page needs authentication
  const needsAuth = AUTHENTICATED_PAGES.some((page) =>
    pathname.startsWith(page)
  );

  // If it's a public page, render children directly
  if (isPublicPage) {
    return <>{children}</>;
  }

  // If it's an authenticated page and user is not authenticated, render children directly
  // (the individual pages will handle their own authentication)
  if (needsAuth && !user && !loading) {
    return <>{children}</>;
  }

  // If it's an authenticated page and user is authenticated, wrap with DashboardLayout
  if (needsAuth && user) {
    return <DashboardLayout>{children}</DashboardLayout>;
  }

  // For other pages (like root "/"), render children directly
  return <>{children}</>;
}
